import { App, Col, InputNumber, Row, Typography } from "antd";
import { usePostField } from "./queries";
import { useQueryClient } from "@tanstack/react-query";
const { Text } = Typography;

const DeliveryTimeField = ({ selectedLocation, handleChange }) => {
  const { notification } = App.useApp();
  const updateDeliveryTime = usePostField(selectedLocation.locationId);
  const queryClient = useQueryClient();
  return (
    <>
      <Row gutter={15} align="middle" marg style={{ marginLeft: 25 }}>
        <Col flex="auto" align="end">
          <Text>Vorlaufzeit:</Text>
        </Col>
        <Col>
          <InputNumber
            size="large"
            min={1}
            addonAfter={"Tage"}
            value={selectedLocation.deliveryTime}
            style={{
              width: 100,
            }}
            controls={false}
            onPressEnter={(val) => {
              const { value: inputValue } = val.target;
              if (Number.isInteger(Number(inputValue)) && inputValue >= 1) {
                updateDeliveryTime.mutate(
                  {
                    crm_dealercode: selectedLocation.dealerCode,
                    delivery_time: Number(inputValue),
                  },
                  {
                    onSuccess: () => {
                      console.log(selectedLocation);
                      notification.success({
                        message: "Aktuallisierung war erfolgreich!",
                      });
                      handleChange({
                        ...selectedLocation,
                        deliveryTime: inputValue,
                      });

                      queryClient.invalidateQueries([
                        "timeSlots",
                        selectedLocation.locationId,
                      ]);
                    },
                    onError: () => {
                      notification.error({
                        message: "Aktuallisierung ist fehlgeschlagen!",
                      });
                    },
                  }
                );
              } else {
                notification.error({
                  message: `Ungültiger Wert!`,
                });
              }
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default DeliveryTimeField;
